import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../app-insights";
import RootPage from "../RootPage";
import localisations from "../../shell/localisation";
import CreatePartitionFeature from "../../features/partitions/create-partition";
import { useAuth0 } from "@auth0/auth0-react";
import { getFieldCompanyId } from "shell/services/fieldCompanyService";

function CreatePartitionPage() {
    const { user } = useAuth0();

    const fieldCompanyId = getFieldCompanyId(user);

    return (
        <RootPage header={localisations.pages.createpartition.heading}>
            <CreatePartitionFeature fieldCompanyId={fieldCompanyId} />
        </RootPage>
    );
}

export default withAITracking(reactPlugin, CreatePartitionPage, "Create Partition Page");
